import { styled } from '@mui/material/styles';
import { Box, Paper, Grid, Card, CardHeader as MuiCardHeader } from '@mui/material';

export const DashboardWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2),
  background: theme.palette.background.default,
  minHeight: '100vh',
  transition: 'all 0.3s ease-in-out',
}));

export const DashboardGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
  overflow: 'hidden',
  height: '100%',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    boxShadow: '0 8px 25px 0 rgba(0,0,0,0.09)',
    transform: 'translateY(-3px)'
  }
}));

export const CardHeader = styled(MuiCardHeader)(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.paper,
  '& .MuiCardHeader-title': {
    fontSize: '1.1rem',
    fontWeight: 700,
    letterSpacing: '0.01em',
  },
  '& .MuiCardHeader-subheader': {
    fontSize: '0.875rem',
  },
  '& .MuiCardHeader-action': {
    margin: 0
  }
}));

export const ChartContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '300px',
  padding: theme.spacing(1),
  position: 'relative',
  '& canvas': {
    borderRadius: '8px',
  }
}));

export const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '10px',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  transition: 'transform 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)'
  }
}));

export const TabPanel = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  transition: 'opacity 0.3s ease-in-out',
}));

export const ChipContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-end'
  }
}));

export const GradientDivider = styled(Box)(({ theme }) => ({
  height: '3px',
  width: '100%',
  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  marginBottom: theme.spacing(3),
  borderRadius: '2px'
}));
